import React from "react";
import { ParagraphInputText, NextConditionData } from "@/model";

import { ParagraphInputsProps } from "../model";
import { NextConditionSortableList } from "../input";


const ParagraphInputTextCardInputs: React.FC<ParagraphInputsProps<ParagraphInputText>> = (props) => {
    const { paragraph, onChange } = props;

    const handleChangeConditions = (conditions: NextConditionData[]) => {
        onChange({
            ...paragraph,
            data: conditions
        });
    };

    return (
        <NextConditionSortableList className="col-span-2 flex flex-col gap-1.5"
                                   required={false}
                                   defaultConditions={paragraph.data ?? []}
                                   onChangeConditions={handleChangeConditions}
        />
    );
};

export default ParagraphInputTextCardInputs;
